import React, { useState, useEffect } from 'react';
import * as moment from 'moment-timezone';
import PropTypes from 'prop-types';
import {
  Table,
  TableHead,
  TableBody,
  Grid,
  Link,
  Button,
  TableRow,
  TableCell,
  CircularProgress,
  IconButton,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import cx from 'classnames';
import { fetchPatientIndividualAppts } from '../../../services/api';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
// import AttachmentIcon from '@material-ui/icons/Attachment';
// import ApptAttachmentModal from './ApptAttachmentModal';

function PatientUpcomingAppt(props) {
  const {
    patientId,
    history,
    classes: { tableTitle, tableContainer, bookedAt },
  } = props;

  const enqueueSnackbar = useSnackbar();
  const pageLimit = 10;

  const [isLoading, setIsLoading] = useState(false);
  const [appts, setAppointments] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);
  //   const [attachment, setAttachment] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        fetchPatientUpcomingApptsInfo();
      } catch (err) {
        enqueueSnackbar("Unable to fetch patient's appointments");
      }
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        fetchPatientUpcomingApptsInfo();
      } catch (err) {
        enqueueSnackbar("Unable to fetch patient's appointments");
      }
      setIsLoading(true);
    })();
  }, [pageIndex]);

  const fetchPatientUpcomingApptsInfo = async () => {
    const status = 'upcoming';
    const appointments = await fetchPatientIndividualAppts(
      patientId,
      status,
      pageLimit,
      pageIndex * 10
    );
    setAppointments(appointments);
    setIsLoading(false);
  };

  const onCancelAppointment = async cancelToken => {
    const { history } = props;
    history.push(`/appointments/cancel/${cancelToken}`);
  };

  const onPageBack = async () => {
    if (pageIndex === 0) {
      enqueueSnackbar('You are on the first page');
    } else {
      setPageIndex(pageIndex - 1);
    }
  };

  const onPageForward = async () => {
    setPageIndex(pageIndex + 1);
  };

  return isLoading ? (
    <div className={props.classes.loading}>
      <CircularProgress />
    </div>
  ) : (
    <>
      <Grid item xs={12} className={tableContainer}>
        {appts && appts.length === 0 ? (
          <p>
            You have no upcoming appointments scheduled at this time, To book an
            appointment{' '}
            {/* <a
              href={`${process.env.REACT_APP_HOMEPAGE_URL +
                '/?patientId=' +
                patientId}`}
            >
              {' '}
              <b>Click Here</b>
            </a> */}
            <a href={process.env.REACT_APP_HOMEPAGE_URL}>
              {' '}
              <b>Click Here</b>
            </a>
          </p>
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className={tableTitle}>Provider</TableCell>
                <TableCell className={tableTitle}>Location or Link</TableCell>
                <TableCell className={tableTitle}>Appointment Date</TableCell>
                <TableCell className={cx(tableTitle, bookedAt)}>
                  Booked At
                </TableCell>
                <TableCell className={tableTitle}>
                  Click below to cancel
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {appts &&
                appts.map(appointment => (
                  <TableRow key={appointment && appointment.id}>
                    <TableCell width="300px">
                      {`${appointment &&
                        appointment.tenancy &&
                        appointment.tenancy.provider &&
                        appointment.tenancy.provider.user
                          .firstName} ${appointment &&
                        appointment.tenancy &&
                        appointment.tenancy.provider &&
                        appointment.tenancy.provider.user &&
                        appointment.tenancy.provider.user.lastName}`}
                    </TableCell>
                    <TableCell width="300px">
                      {appointment &&
                      appointment.tenancy &&
                      appointment.tenancy.virtualRoomUrl ? (
                        <Link
                          href={
                            appointment &&
                            appointment.tenancy &&
                            appointment.tenancy.virtualRoomUrl
                          }
                        >
                          {appointment &&
                            appointment.tenancy &&
                            appointment.tenancy.location}
                        </Link>
                      ) : (
                        appointment &&
                        appointment.tenancy &&
                        appointment.tenancy.location
                      )}
                    </TableCell>
                    <TableCell width="300px">
                      {moment(appointment && appointment.time)
                        .tz('America/New_York')
                        .format('MM/DD/YYYY hh:mma z')}
                    </TableCell>
                    <TableCell className={bookedAt}>
                      {moment(appointment && appointment.createdAt)
                        .tz('America/New_York')
                        .format('MM/DD/YYYY hh:mma z')}
                    </TableCell>
                    <TableCell>
                      <Button
                        onClick={() =>
                          onCancelAppointment(
                            appointment && appointment.cancelToken
                          )
                        }
                        variant="contained"
                      >
                        Cancel
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        )}
      </Grid>
      {appts && appts.length === 0 ? null : (
        <div className={props.classes.pageTurners}>
          <IconButton disabled={pageIndex === 0}>
            <ArrowBackIosIcon
              style={{ opacity: pageIndex === 0 ? '0.5' : '1.0' }}
              color="primary"
              variant="contained"
              onClick={onPageBack}
            />
          </IconButton>
          <IconButton>
            <ArrowForwardIosIcon
              style={{ opacity: appts.length < pageLimit ? '0.5' : '1.0' }}
              color="primary"
              variant="contained"
              onClick={onPageForward}
            />
          </IconButton>
        </div>
      )}
    </>
  );
}

PatientUpcomingAppt.propTypes = {
  patient: PropTypes.object,
};

const styles = theme => ({
  pageTurners: {
    width: '100%',
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  tableTitle: {
    fontSize: '0.7rem',
    lineHeight: '14px',
    textTransform: 'uppercase',
    color: '#606A74',
    fontWeight: 'normal',
  },
  tableContainer: {
    overflowX: 'auto',
  },
});

export default withStyles(styles)(PatientUpcomingAppt);
